import { List, EditButton, Datagrid, TextField, BooleanField, useRecordContext } from 'react-admin';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import { DeleteWithDialogAction } from '../../common/DeleteWithDialogAction';
import { format } from 'date-fns';
import useIsPermission from '../../hooks/useIsPermission';
import PermissionBasedActions from '../../common/PermissionBasedActionsButton';
import CouponsMetaDataField from './CouponsMetaDataField';
import { ContentCopy } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import ConfirmDeleteButton from '../../common/ConfirmDeleteButton';

const FormattedStartEndField = (props: any) => {
    const record = useRecordContext<any>();

    return record ? (
        <div className={'flex flex-col text-sm space-y-1'}>
            {record.startedAt && (
                <div className={'flex items-center space-x-2'}>
                    <div className={'whitespace-nowrap'}>
                        {format(new Date(record.startedAt), 'dd/MM/yyyy hh:mm a')}
                    </div>
                </div>
            )}
            {record.expiringAt && (
                <div className={'flex items-center  space-x-2'}>
                    <div className={'whitespace-nowrap'}>
                        {format(new Date(record.expiringAt), 'dd/MM/yyyy hh:mm a')}
                    </div>
                </div>
            )}
        </div>
    ) : null;
};

FormattedStartEndField.defaultProps = {
    source: 'started_at',
    label: 'Start - End',
};

const CopyCodeField = () => {
    const record = useRecordContext<any>();

    const handleCopy = () => {
        if (record?.code) {
            navigator.clipboard
                .writeText(record.code)
                .then(() => {})
                .catch(err => {
                    console.error('Failed to copy code:', err);
                });
        }
    };

    return record ? (
        <div className="flex items-center gap-2">
            <span>{record.code}</span>
            <Tooltip title="Copy Code">
                <IconButton size="small" onClick={handleCopy}>
                    <ContentCopy fontSize="small" />
                </IconButton>
            </Tooltip>
        </div>
    ) : null;
};

CopyCodeField.defaultProps = {
    label: 'Code',
};

const CouponList = () => {
    const { isUpdatable, isWritable, isDeletable } = useIsPermission('COUPONS');
    return (
        <List
            actions={<PermissionBasedActions isWritable={isWritable} />}
            queryOptions={{
                refetchOnWindowFocus: false,
                refetchOnReconnect: false,
            }}
        >
            <Datagrid bulkActionButtons={false}>
                <CopyCodeField />
                <CouponsMetaDataField label="Coupon Details" />
                <BooleanField source={'hidden'} />
                <FormattedStartEndField source="startedAt" />
                <FormattedDateTimeField source="createdAt" />
                {isUpdatable && <EditButton />}
                {isDeletable && <ConfirmDeleteButton />}
            </Datagrid>
        </List>
    );
};
export default CouponList;
